import Vue from "vue";
import { apiV1Auth } from "./resources/api-v1-auth";

const state = Vue.observable({
  authenticated: false,
  checked: false,
});

let pending = null;

function fetchSession() {
  return apiV1Auth
    .session()
    .then((response) => {
      state.authenticated = !!(response.data && response.data.authenticated);
    })
    .catch(() => {
      state.authenticated = false;
    })
    .finally(() => {
      state.checked = true;
      pending = null;
    });
}

function checkSession(force) {
  if (!force && state.checked) return Promise.resolve(state.authenticated);
  if (!pending) pending = fetchSession();
  return pending.then(() => state.authenticated);
}

function setAuthenticated(value) {
  state.authenticated = value;
  state.checked = true;
}

export default {
  state,
  checkSession,
  setAuthenticated,
};
